import _has from 'lodash/has';
import _isNil from 'lodash/isNil';
import type { AxiosError, AxiosResponse } from 'axios';

export function extractErrorMessage(err: string | AxiosError | null): string | null {
  if (_isNil(err)) {
    return err;
  } else if (typeof err === 'string') {
    return err;
    // eslint-disable-next-line no-unsafe-optional-chaining -- err is narrowed to AxiosError by prior branches
  } else if (err?.response && (err?.response as AxiosResponse & { statusType: number }).statusType === 5) {
    return err?.response.statusText || 'Server Error';
  } else if (_has(err, ['response', 'data', '0', 'message'])) {
    // eslint-disable-next-line no-unsafe-optional-chaining -- _has already confirmed the path exists
    return (err?.response?.data as { message: string }[])[0].message;
  } else if (_has(err, 'response.data.data')) {
    const res = err.response?.data as { data: string };
    return res.data;
  } else if (_has(err, ['response', 'data', 'errors'])) {
    const res = err.response?.data as {
      errors: Array<
        | string
        | {
            errors?: Array<{
              message: string;
              instance?: {
                name?: string;
              };
            }>;
          }
      >;
    };
    if (Array.isArray(res.errors)) {
      const allMessages = res.errors.flatMap((errorItem) => {
        if (typeof errorItem === 'string') {
          return errorItem;
        } else if (typeof errorItem === 'object' && errorItem.errors && Array.isArray(errorItem.errors)) {
          return errorItem.errors.map((e) => {
            if (e.message) {
              const taskName = e.instance?.name;
              const instance = e.instance as { name?: string; id?: number };
              if (taskName && typeof instance?.id === 'number') {
                return `${e.message} (Task: ${taskName}, ID: ${instance.id})`;
              } else if (taskName) {
                return `${e.message} (Task: ${taskName})`;
              }
              return e.message;
            }
            return JSON.stringify(e);
          });
        } else if (typeof errorItem === 'object') {
          return JSON.stringify(errorItem);
        }
        return [];
      });

      if (allMessages.length === 1) {
        return allMessages[0];
      }
      return '• ' + allMessages.join('\n• ');
    }
  } else if (err?.message) {
    return err?.message;
  }

  return JSON.stringify(err);
}
